module.exports = __webpack_public_path__ + "media/img/pages/companies/wwf-cf3f3df44fe5c7d385c874c761e97ebc.png";